import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useAnalyticsScript } from 'hooks/useAnalyticsScript';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { translate } from 'lib';

const AnalyticsHelmet = () => {
  const { scripts, domain } = useAnalyticsScript();
  const { header, footer } = scripts;
  const location = useLocation();
  const [subTitle, setSubTitle] = useState('');
  const taxonomy = useSelector((state) => state.taxonomy.data);

  // Inject scripts just below head
  const injectHeaderScripts = () => {
    for (let idx = header.length - 1; idx >= 0; idx--) {
      const scriptStr = header[idx];
      const temp = document.createElement('div');
      temp.innerHTML = scriptStr;
      const script = temp.querySelector('script');
      if (!script) continue;

      const id = `head-script-${idx}`;
      const existing = document.getElementById(id);
      if (existing) existing.remove();

      const newScript = document.createElement('script');
      newScript.id = id;

      if (script.src) {
        newScript.src = script.src;
        newScript.async = script.async ?? true;
      } else {
        newScript.textContent = script.innerHTML;
      }

      document.head.insertBefore(newScript, document.head.firstChild);
    }
  };

  // Inject footer scripts
  const injectFooterScripts = () => {
    for (let idx = footer.length - 1; idx >= 0; idx--) {
      const scriptStr = footer[idx];
      const temp = document.createElement('div');
      temp.innerHTML = scriptStr;
      const script = temp.querySelector('script');
      if (!script) continue;

      const id = `footer-script-${idx}`;
      const old = document.getElementById(id);
      if (old) old.remove();

      const newScript = document.createElement('script');
      newScript.id = id;

      if (script.src) {
        newScript.src = script.src;
        newScript.async = script.async ?? true;
      } else {
        newScript.textContent = script.innerHTML;
      }

      const footerElement = document.querySelector('footer') || document.body;

      footerElement.insertBefore(newScript, footerElement.firstChild);
    }
  };

  // useEffect(() => {
  //   // injectHeaderScripts();
  //   // injectFooterScripts();

  //   // Optionally track page view
  //   if (typeof window.gtag === 'function') {
  //     window.gtag('config', process.env.REACT_APP_GOOGLE_ANALYTICS_MEASUREMENT_ID, {
  //       page_path: location.pathname + location.search,
  //     });
  //     console.log('[GA] Page tracked:', location.pathname);
  //   }
  // }, [location.pathname]);

  const capitalizeFirst = (str) => str.charAt(0).toUpperCase() + str.slice(1);

  const mapRoute = {
    'portfolio-evidence': 'assignment',
    'external-exam': 'externalExam',
    event: 'event',
  };

  useEffect(() => {
    if (domain) {
      const title = location.pathname.split('/')[2] || '';

      const taxonomyRef = translate(taxonomy)(mapRoute[title]);

      setSubTitle(taxonomyRef ?? title);
    }
  }, [location.pathname, domain]);

  return (
    <>
      <Helmet>
        {injectHeaderScripts()}
        <title>{capitalizeFirst(subTitle)}</title>
        <meta charSet="utf-8" />
        <meta
          name="description"
          content="Your site description"
        />
      </Helmet>
      {injectFooterScripts()}
    </>
  );
};

export default AnalyticsHelmet;
